module.exports = __webpack_public_path__ + "static/media/spa.cfe916a8.jpg";